import { useEffect, useState } from "react";
import { AiFillCheckCircle } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import Gap from "../../components/Gap";
import Text from "../../components/Text";
import { router } from "../../Constants";
import { showLog } from "../../utils/log";

function TransactionProcessed() {
  let navigate = useNavigate();
  let [countNumber, setCountNumber] = useState(3);

  useEffect(() => {
    showLog("TransactionProcessed Masuk useEffect 1");
    //     setTimeout(function() => { if(setCountNumber  == 5) {navigate(router +'/bill')}
    // }, 2000);
    let myInterval = setTimeout(() => {
      if (countNumber > 0) {
        setCountNumber(countNumber - 1);
      }
      if (countNumber == 0) {
        navigate(router + "/bill");
      }
      return () => clearInterval(myInterval);
    }, 1000);
  });

  return (
    <div style={{ position: "fixed", height: "100%", width: "100%" }}>
      <div>
        <div
          onClick={() => navigate(`${router}/bill`)}
          style={{
            marginLeft: "87%",
            marginTop: 10,
            borderRadius: "70%",
            backgroundColor: "#3582B9",
            width: 30,
            height: 30,
          }}
        >
          <div
            size={30}
            color="#8B78FF"
            style={{ textAlign: "center", paddingTop: 4 }}
          >
            <span style={{ color: "white" }}> {countNumber}</span>
          </div>
        </div>
      </div>
      <div
        style={{
          display: "grid",
          justifyContent: "center",
          alignItems: "center",
          height: "80%",
        }}
      >
        <div style={{ margin: "0 10px" }}>
          <div
            style={{
              display: "grid",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <AiFillCheckCircle size={130} color="#03B134" />
          </div>
          <Gap height={10} />
          <div
            style={{
              width: "100%",
              display: "grid",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Text className="fonts700" style={{ fontSize: 25 }}>
              Transaksi sukses
            </Text>
          </div>
          <Gap height={20} />
          <div style={{ display: "flex" }}>
            <span
              className="fonts700"
              style={{ color: "#000", textAlign: "center", fontSize: 18 }}
            >
              Pesanan sedang diproses, mohon menunggu
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TransactionProcessed;
